import { Component, Input } from '@angular/core';

import { Table } from '../../classes/table';
import { TableRow } from '../../classes/row';

@Component({
  selector: '[uex-table-content]',
  templateUrl: './content.component.html',
  host: {
    'class': 'uex-table-content'
  }
})
export class TableContentComponent {
  @Input() table: Table;
  @Input() data: Array<TableRow>;
}
